import React, { useRef } from 'react';
import { Button } from './ui/button';
import { Upload, X } from 'lucide-react';

// Reads a File into a base64 data URL (compressed via canvas for images > ~800px)
function readAsBase64(file, maxW = 1200, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        try {
          const scale = Math.min(1, maxW / img.width);
          const w = Math.round(img.width * scale);
          const h = Math.round(img.height * scale);
          const canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/jpeg', quality));
        } catch (e) { resolve(reader.result); }
      };
      img.onerror = () => resolve(reader.result);
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export default function FileUpload({ value, onChange, label = 'Upload', aspect = 'square', maxW = 1200, previewClassName = '' }) {
  const ref = useRef();
  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const b64 = await readAsBase64(file, maxW);
    onChange(b64);
    e.target.value = '';
  };
  const clear = () => onChange('');

  const previewBox = aspect === 'cover'
    ? 'w-full h-28 rounded-xl'
    : aspect === 'wide'
    ? 'w-full h-24 rounded-xl'
    : 'w-20 h-20 rounded-full';

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <div className={`${previewBox} ${previewClassName} bg-neutral-100 border border-neutral-200 overflow-hidden flex-shrink-0 grid place-items-center text-neutral-400 text-xs`}>
          {value ? (
            <img src={value} alt="preview" className="w-full h-full object-cover" />
          ) : 'Sem imagem'}
        </div>
        <div className="flex flex-wrap gap-2">
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={onPick} />
          <Button type="button" variant="outline" size="sm" className="gap-1.5 border-neutral-300" onClick={() => ref.current?.click()}>
            <Upload size={14} /> {value ? 'Alterar' : label}
          </Button>
          {value && (
            <Button type="button" variant="outline" size="sm" className="gap-1.5 border-neutral-300 text-red-600 hover:bg-red-50" onClick={clear}>
              <X size={14} /> Remover
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
